import React from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#C4836A] text-white hover:bg-[#B07259] shadow-md hover:shadow-lg focus:ring-[#C4836A]',
    secondary: 'bg-[#8B9E8B] text-white hover:bg-[#7A8C7A] shadow-sm hover:shadow-md focus:ring-[#8B9E8B]',
    outline: 'border-2 border-[#8B9E8B] text-[#5A6B5A] hover:bg-[#8B9E8B] hover:text-white focus:ring-[#8B9E8B]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={clsx(baseStyles, variants[variant], sizes[size], fullWidth && 'w-full', className)} {...props} data-id="element-276">
      {children}
    </motion.button>;
}